import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/paystations/pay-station/:payStationId/levels/clear-coins/`;

type MutationFnType = typeof mutationFn;

const mutationFn = ({
    payStationId,
    parkingId,
}: {
    payStationId: string;
    parkingId: string;
}): Promise<Record<string, any>> => {
    return axios.post(formatResourcePath(RESOURCE, { payStationId, parkingId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useClearCoinsAvailability };
